import * as moment from 'moment';

import { Stock } from './stock';
import { Ship } from './ship';

import { Quota } from './quota';
import { QuotaMovement } from './quota-movement';

import { FilterHandler } from '../shared/filter-handler';

export class QuotaItem extends Quota {
  id: number;
  quota_type: string;
  name: string;
  get_quota_type_display: string;
  creation_date: moment.Moment;
  last_update_date: moment.Moment;
  stock: Stock = new Stock();
  ships: Ship[] = [];
  quota_movements: QuotaMovement[];

  multiple: boolean;
  selectLabel: string;
  label: string;
  stockLabel: string;

  public apiMap(values: Object = {}) {
    const stock = new Stock();
    const quota = new QuotaItem(values);
    quota.stock = stock.apiMap(values['stock']);
    quota.quota_movements = [];

    if (values['ships']) {
      quota.multiple = this.quota_type === 'multiple';
      for (const ship of values['ships']) {
        quota.ships.push(new Ship(ship));
      }
    }

    quota.quota_movements = [];
    if (values['movements']) {
      for (const movement of values['movements']) {
        const m = new QuotaMovement().apiMap(movement);
        quota.quota_movements.push(m);
      }
    }
    quota.setLabel();
    quota.alert = quota.calculateAlert();
    return quota;
  }

  public serialize() {
    const record = super.serialize();
    record['stock'] = this.stock.id;
    record['ships'] = this.ships.map(function (ship) {
      return ship.id;
    });

    return record;
  }

  private setLabel() {
    if (this.quota_type === 'multiple') {
      const nombre = this.name && this.name.trim().length > 0 ? this.name : 'Varios';
      this.selectLabel = `Entidad: ${this.name}`;
      this.label = nombre;
      this.stockLabel = this.stock.name;
    } else {
      this.selectLabel = `Buque: ${(this.ships && this.ships[0].name) || ''} ${(this.ships && this.ships[0].code) || ''}`;
      this.label = `${this.ships[0] && this.ships[0].name} (${this.ships[0] && this.ships[0].code})`;
      this.stockLabel = this.stock.name;
    }
  }
}

export class QuotaFilter extends FilterHandler {
  stock: Stock[] = [];
  ships: Ship[] = [];
  year: string;

  constructor(values: Object = {}) {
    super();

    this.stock = [];
    this.ships = [];
    this.year = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/quota-item.ts